import { Component, Inject, Input, OnInit, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSelectionList } from '@angular/material/list';
import { UMPCategory } from '../../../../utils/utils';
import { DefaultValuesService } from '../../../../services/defaultvalues.service';
import { AddGroupDialogue } from '../../home/edituser/addgroupdialogue/addgroupdialogue.component';
import { SharedMersyRolesService, MersyPersonae } from '../../../../services/shared-mersy-roles.service';
import { Subscription } from 'rxjs';

export type MersyRoleFilter = 'mersy' | 'marketquery' | 'globalbranchexcellence' | 'niops' | 'tax' | 'safetysystemexcellence' | 'inco';

@Component({
  selector: 'commonselection-mersy-list',
  templateUrl: './commonselection-list.component.html', 
  styleUrls: ['./commonselection-list.component.less'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class CommonselectionMersyListComponent implements OnInit, OnDestroy {

    @Input() RoleType: string = '';
    @Input() Umpcategory: UMPCategory = {} as UMPCategory;
    @Input() MersyFilter: MersyRoleFilter = 'mersy';
    
    dataCopy: MersyPersonae[] = [];
    @ViewChild(MatSelectionList) selectionList!: MatSelectionList;

    public userName: String = '';
    userId = '';

    searchString: string = '';
    filteredRoleTypeRoles: MersyPersonae[] = [];

    RoleTypeRoles: MersyPersonae[] = [];
    Response_State: number = -2;
    errorResponse: any;
    isCallSucceed: number = 0;

    dialogRef: MatDialogRef<AddGroupDialogue, any> | undefined;
    private subscriptions: Subscription[] = [];

    constructor(
        private route: ActivatedRoute,
        private toastrService: ToastrService,
        private dialogForm: MatDialog,
        private defaults: DefaultValuesService,
        private sharedMersyRolesService: SharedMersyRolesService,
        @Inject('BASE_URL') private baseUrl: string
    ) {
        this.updateRolesResults();
        this.userId = this.route.snapshot.paramMap.get('userId') || '';
        
        this.subscriptions.push(
            defaults.resetBulkGroupTrigger$.subscribe(() => this.resetData())
        );
    }

    ngOnInit() {
        this.initializeSharedService();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    private initializeSharedService() {
        this.subscriptions.push(
            this.sharedMersyRolesService.filteredRoles$.subscribe(filteredRoles => {
                if (filteredRoles) {
                    let selectedData: MersyPersonae[] = [];
                    switch (this.MersyFilter) {
                        case 'mersy':
                            selectedData = filteredRoles.mersyRoles;
                            break;
                        case 'marketquery':
                            selectedData = filteredRoles.marketQueryRoles;
                            break;
                        case 'globalbranchexcellence':
                            selectedData = filteredRoles.globalBranchRoles;
                            break;
                        case 'niops':
                            selectedData = filteredRoles.niOpsRoles;
                            break;
                        case 'tax':
                            selectedData = filteredRoles.taxRoles;
                            break;
                        case 'safetysystemexcellence':
                            selectedData = filteredRoles.safetySystemExcellenceRoles;
                            break;
                        case 'inco':
                            selectedData = filteredRoles.incoRoles;
                            break;
                    }
                    
                    this.dataCopy = [...selectedData];
                    this.assignValues({ personae: selectedData });
                }
            })
        );

        this.subscriptions.push(
            this.sharedMersyRolesService.loading$.subscribe(isLoading => {
                this.Response_State = isLoading ? -2 : this.Response_State;
            })
        );

        this.subscriptions.push(
            this.sharedMersyRolesService.error$.subscribe(error => {
                if (error) {
                    this.errorResponse = error;
                    this.Response_State = -1;
                }
            })
        );

        this.sharedMersyRolesService.loadMersyRoles(this.baseUrl, this.userId);
    }

    async updateRolesResults() {
        this.filteredRoleTypeRoles = this.searchByValue(this.RoleTypeRoles, "persona", this.searchString);
    }

    isRoleSelected(item: MersyPersonae): boolean {
        return this.defaults.groupList.some(group =>
            group.Id === item.id && group.UmpCategory === this.Umpcategory
        );
    }

    searchByValue(items: MersyPersonae[], filterProperty: string, query: string) {
        return items.filter(item => {
            if (query.trim() === '') {
                return true;
            } else {
                return item[filterProperty].toLowerCase().includes(query.trim().toLowerCase())
            }
        })
    }

    funcGetRoles() {
        this.Response_State = -2;
        this.sharedMersyRolesService.refreshData(this.baseUrl, this.userId);
    }

    assignValues(data: { personae: MersyPersonae[] }) {
        this.RoleTypeRoles = data.personae || [];
        this.filteredRoleTypeRoles = [...this.RoleTypeRoles];
        this.updateRolesResults();

        if (this.RoleTypeRoles?.length) {
            this.Response_State = 1;
        }
        else {
            this.Response_State = 0;
        }
    }

    resetData() {
        this.selectionList?.deselectAll();
        this.searchString = '';
        this.assignValues({ personae: [...this.dataCopy] });
    }

    itemSelected(event) {
        if (event.options[0]._selected) {
            this.onSelect(event.options[0]._value);
        } else {
            this.onDeselect(event.options[0]._value);
        }
    }

    onSelect(selectedItem) {
        this.defaults.addGroupListItem({ Personae: selectedItem.persona, Id: selectedItem.id, UmpCategory: this.Umpcategory });
    }

    onDeselect(selectedItem) {
        this.defaults.removeGroupListItem(selectedItem.id);
    }
}
